export const  sidebarMenus =[{
    btnClass:"btn bg-light font-weight-bold text-secondary",
    iconType:"home",
    title:"Home",
  },
  {
    btnClass:"btn bg-light font-weight-bold text-secondary",
    iconType:"folder",
    title:"Folders",
  },
  { 
    btnClass:"btn bg-light font-weight-bold text-secondary",
    iconType:"clock",
    title:"Photos",
  },
  {
    btnClass:"btn bg-light font-weight-bold text-secondary",
    iconType:"star",
    title:"Videos",
  },
  {
    btnClass:"btn bg-light font-weight-bold text-secondary",
    iconType:"alert-circle",
    title:"Documents",
  }]